module.exports = __webpack_public_path__ + "img/member_save_logo.a6039072.png";